export default __webpack_public_path__ + "static/media/mando.6a0b40f9.jpg";